import React, { useEffect, useState } from "react";
import {
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View
} from "react-native";
import Modal from "react-native-modal";
import { CloseIcon, EditIcon } from "../assets/icons";

function ModalAddScreening(props) {
  const { visible, code, setCode, hideDialog, onAdd } = props;
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    setCode("");
  }, []);

  const onSubmit = () => {
    if (code === "") {
      setIsError(true);
      return;
    }
    onAdd();
    hideDialog();
  };
  return (
    <Modal isVisible={visible} onBackdropPress={hideDialog}>
      <View style={styles.parentBox}>
        <View
          style={{
            ...styles.flexOne,
            justifyContent: "space-between",
            marginBottom: 12
          }}
        >
          <View style={styles.flexOne}>
            <EditIcon width={18} height={18} fill="#000" />
            <Text style={styles.txTitle}>Tambah Screening</Text>
          </View>
          <TouchableOpacity onPress={hideDialog}>
            <CloseIcon />
          </TouchableOpacity>
        </View>
        <TextInput
          placeholder={"Masukkan nama target screening"}
          style={[
            styles.inputText, 
            isError && {
              borderStyle: "solid",
              borderWidth: 1,
              borderColor: "#ff0000"
            }
          ]}
          placeholderTextColor="#999"
          onChangeText={(text) => {
            setCode(text);
          }}
          onChange={(e) => {
            setCode(e.target.value);
          }}
          value={code}
        />
        <TouchableOpacity onPress={onSubmit} style={styles.button}>
          <Text style={styles.txBtn}>{"Mulai"}</Text>
        </TouchableOpacity>
      </View>
    </Modal>
  );
}
const styles = StyleSheet.create({
  parentBox: {
    width: "100%",
    backgroundColor: "#fff",
    borderRadius: 10,
    paddingTop: 16,
    paddingLeft: 12,
    paddingRight: 12,
    paddingBottom: 16
  },
  inputText: {
    width: "100%",
    backgroundColor: "#fff",
    borderWidth: 1,
    borderColor: "#DEDEDE",
    borderStyle: "solid",
    borderRadius: 10,
    padding: 12,
    paddingBottom: 11,
    paddingTop: 11,
    textAlign: "center",
    fontFamily: "Archivo-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: 12,
    lineHeight: 12,
    maxHeight: 36
  },
  button: {
    backgroundColor: "#6724E2",
    borderRadius: 10,
    width: "100%",
    height: 36,
    justifyContent: "center",
    alignItems: "center",
    marginTop: 12
  },
  txBtn: {
    fontFamily: "Archivo-Bold",
    fontStyle: "normal",
    textAlign: "center",
    fontWeight: "700",
    fontSize: 12,
    lineHeight: 13,
    color: "#FFF",
    marginLeft: 6
  },
  flexOne: {
    flexDirection: "row",
    alignItems: "center"
  },
  txTitle: {
    fontFamily: "Archivo-Bold",
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: 12,
    lineHeight: 14,
    color: "#000",
    marginLeft: 6
  }
});

export default ModalAddScreening;
